import { Brain, CircleDashed, CircleCheck, ImageIcon } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'
import type { ConsumoIA, ResumenProveedor } from '../types/consumoIA'

const formatCurrency = (amount: number) =>
  new Intl.NumberFormat('es-PE', { style: 'currency', currency: 'USD' }).format(amount)

interface Props {
  resumen: ResumenProveedor
  registros: ConsumoIA[]
  viewMode?: 'laboratorio' | 'proveedor'
}

export function ResumenProveedorCard({ resumen, registros, viewMode = 'laboratorio' }: Props) {
  const { pendiente, realizado } = registros.reduce(
    (acc, r) => {
      const monto = viewMode === 'proveedor' ? r.costo_proveedor_registro : r.costo_cliente
      const isPending = viewMode === 'proveedor'
        ? r.estado_pago_proveedor === 'pendiente'
        : r.estado_cobro === 'pendiente'
      if (isPending) acc.pendiente += monto
      else acc.realizado += monto
      return acc
    },
    { pendiente: 0, realizado: 0 }
  )

  const stats = [
    {
      label: 'Total imágenes procesadas',
      value: resumen.total_imagenes.toLocaleString(),
      icon: ImageIcon,
    },
    {
      label: 'Pago pendiente',
      value: formatCurrency(pendiente),
      icon: CircleDashed,
    },
    {
      label: viewMode === 'proveedor' ? 'Pago realizado' : 'Cobro realizado',
      value: formatCurrency(realizado),
      icon: CircleCheck,
    },
    {
      label: 'Registros',
      value: resumen.registros_count.toString(),
      icon: Brain,
    },
  ]

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
      {stats.map((stat) => (
        <Card
          key={stat.label}
          className="border border-gray-300 dark:border-gray-700 bg-gradient-to-r from-violet-500/15 via-violet-500/5 via-50% to-transparent dark:from-violet-800/20 dark:via-violet-900/10 dark:via-50% dark:to-transparent"
        >
          <CardContent className="p-4 flex items-center gap-3">
            <div className="rounded-lg bg-violet-500/10 p-2 shrink-0">
              <stat.icon className="h-5 w-5 text-violet-500" />
            </div>
            <div>
              <p className="text-xs text-gray-500 dark:text-gray-400">{stat.label}</p>
              <p className="text-lg font-semibold text-black dark:text-white tabular-nums">
                {stat.value}
              </p>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}
